export default __webpack_public_path__ + "static/media/hbs-k-bpk-2.108c2bd1.png";